import Testimonial from "../models/Testimonial";
export const TestimonialMixin = {
  data() {
    return {
      testimonial: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Testimonial({
          user_id: undefined,
          alias: '',
          link: '',
          comment: '',
          is_pinned: false,
          show_photo: false,
          published_at: undefined,
      })
    }
  }
}
